import { Routes, Route } from "react-router-dom";

import ObligationsPage from "../pages/ObligationsPage";

import ObligationDetailPage from "../pages/ObligationDetailPage";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ObligationsPage />} />

      <Route path="/obligation/:id" element={<ObligationDetailPage />} />
    </Routes>
  );
}

export default AppRoutes;
